export default () => ({
  fbclidCreationTime: null,
  fbclid: null,
  fbEventSuffixId: null
})
